import React from 'react';
import { Fence, HandHelping, Hammer, PencilLine, Eraser, Trash, Delete, PaintBucket, Move, LayoutDashboard } from 'lucide-react';
import '../../css/TutorialPopupStyling.css';
import CollapsibleSection from "../CollapsibleSection";

const MainPageTutorialFirst = () => {
    return (
        <div className={"tutorial-first-page-body"}>
            <div className={"tutorial-fp-header"}>
                <p className={"tutorial-fp-header-text"}>
                    Design any garden layout with our flexible grid system. Create custom shapes and sections that
                    match your unique growing space.
                </p>
            </div>

            <CollapsibleSection
                title="How to Use"
                icon={HandHelping}
                iconColor="text-emerald-200"
                defaultExpanded={false}
            >
                <div className={"how-to-use-section"}>
                    <p className={"htu-item"}>&bull; Each grid cell represents exactly 1 square foot of garden space</p>
                    <p className={"htu-item"}>&bull; Use different tools to build your garden plots, they will be
                        tracked individually</p>
                    <p className={"htu-item"}>&bull; After layout, denote and save plots to plan specific plants for
                        each area</p>
                    <p className={"htu-item"}>&bull; Each plot can be assigned to the same garden, but will be monitored
                        separately</p>
                    <p className={"htu-item"}>&bull; Mirror your actual garden plots as closely as possible for best
                        results</p>
                </div>
            </CollapsibleSection>

            <CollapsibleSection
                title="Available Tools"
                icon={Hammer}
                iconColor="text-emerald-200"
                badge="6 tools"
                defaultExpanded={false}
            >
                <div className={"available-tools-section"}>
                    <div className={"available-tool"}>
                        <PencilLine size={24} className={"available-tools-icon-add"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Add</div>
                            <div className={"available-tools-description"}>Place new 1x1 ft cells on your garden grid
                                with precision
                            </div>
                        </div>
                    </div>

                    <div className={"available-tool"}>
                        <Eraser size={24} className={"available-tools-icon-remove"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Remove</div>
                            <div className={"available-tools-description"}>Delete individual cells like an eraser for
                                fine adjustments
                            </div>
                        </div>
                    </div>

                    <div className={"available-tool"}>
                        <Delete size={24} className={"available-tools-icon-delete"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Delete</div>
                            <div className={"available-tools-description"}>Remove all connected cells in one click
                                (flood delete)
                            </div>
                        </div>
                    </div>

                    <div className={"available-tool"}>
                        <Trash size={24} className={"available-tools-icon-clear"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Clear</div>
                            <div className={"available-tools-description"}>Wipe entire garden grid clean for fresh start
                            </div>
                        </div>
                    </div>

                    <div className={"available-tool"}>
                        <PaintBucket size={24} className={"available-tools-icon-fill"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Fill</div>
                            <div className={"available-tools-description"}>Paint bucket tool to quickly fill connected
                                areas
                            </div>
                        </div>
                    </div>

                    <div className={"available-tool"}>
                        <LayoutDashboard size={24} className={"available-tools-icon-denote"}/>
                        <div className={"available-tools-text"}>
                            <div className={"available-tools-name"}>Denote</div>
                            <div className={"available-tools-description"}>Mark and organize garden areas for plant
                                planning
                            </div>
                        </div>
                    </div>
                </div>

            </CollapsibleSection>

            <div className={"tutorial-fp-header"}>
                <p className={"tutorial-fp-header-text"}>
                    You can adjust the grid dimensions if you need to design larger garden plots. The grid is used
                    solely for laying out individual garden plots—it does not control the overall positioning of
                    multiple gardens. Each garden plot is treated as its own standalone entity.
                    We recommend designing one garden plot at a time for the best experience.
                </p>
            </div>
        </div>
    )
}

export default MainPageTutorialFirst;